import {IconButton, Tooltip} from "@mui/material";
import SourceIcon from "@mui/icons-material/Source";
import {blue} from "@mui/material/colors";

import useOpenUrlInNewTab from "../../hooks/useOpenUrlInNewTab";

const linkButtonStyle = {
    width: '2rem',
    height: '2rem',
    borderRadius: '0.5rem',
    border: '1px solid #ccc',
    borderColor: blue[200],
    padding: 0
};

export default function BackupContentButton() {

    const openUrlInNewTab = useOpenUrlInNewTab();
    const openBackupContent = () => openUrlInNewTab(process.env.REACT_APP_SESSION_BACKUP_CONTENT_PATH);

    return <>
        <Tooltip title="Backup Content" arrow>
            <IconButton onClick={openBackupContent} sx={linkButtonStyle}>
                <SourceIcon sx={{color: blue[700]}}/>
            </IconButton>
        </Tooltip>
    </>;
}